import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { Guid, isNotNil, Nillable } from '@web/utils';
import { ImageThumbnailComponent } from '@web/shared/ui';
import { PublicBrandBannerDataSourceService } from '../../services/public-brand-banner-data-source.service';

@Component({
  selector: 'app-public-brand-banner-carousel-item',
  imports: [CommonModule, ImageThumbnailComponent, NgOptimizedImage],
  templateUrl: './public-brand-banner-carousel-item.component.html',
  styleUrl: './public-brand-banner-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBrandBannerCarouselItemComponent {
  private readonly bannerDataSource = inject(
    PublicBrandBannerDataSourceService,
  );

  public readonly bannerId = input.required<Guid>();
  public readonly slug = input.required<string>();
  public readonly imageSrc = input.required<string>();
  public readonly mobileImageSrc = input<Nillable<string>>();
  public readonly imageAlt = input.required<string>();
  public readonly externalLink = input<Nillable<string>>();

  protected readonly isNotNil = isNotNil;

  public async handleLinkClick(event: MouseEvent): Promise<void> {
    event.preventDefault();

    const url = this.externalLink();

    if (!url) {
      return;
    }

    await firstValueFrom(
      this.bannerDataSource.registerRedirect({
        id: this.bannerId(),
        slug: this.slug(),
      }),
    );
    window.open(url, '_blank');
  }
}
